import { Link } from 'react-router-dom';

const steps = [
  { num: '01', icon: 'ri-discuss-line', title: '需求諮詢', desc: '與業務專員進行初步溝通，說明您的品牌定位、目標族群、預計銷售通路與預算範圍，雙方確認合作方向。' },
  { num: '02', icon: 'ri-flask-line', title: '配方提案', desc: '研發團隊依需求提出配方建議，說明原料功效、成分比例與初步報價，客戶確認後進行試製樣品。' },
  { num: '03', icon: 'ri-box-3-line', title: '包裝設計', desc: '提供包裝規格建議，協助客戶確認容器選型、標示版面配置，並審查包裝文字符合食品標示法規。' },
  { num: '04', icon: 'ri-shield-check-line', title: '檢驗認證', desc: '樣品送第三方機構進行安全性檢驗，出具微生物、重金屬、農藥殘留等完整 CoA 檢驗報告，確保合規上市。' },
  { num: '05', icon: 'ri-building-line', title: '量產確認', desc: '簽訂合約、確認訂單數量後正式進入量產，生產過程皆有品管人員把關，生產週期依實際訂單量調整。' },
  { num: '06', icon: 'ri-truck-line', title: '完成交貨', desc: '成品通過品管驗收後按約定時程出貨，提供完整出貨文件，後續持續追蹤並提供技術支援。' },
];

export default function ServiceProcessSection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            服務流程
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">六步驟完整代工流程</h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            清晰透明的服務流程，讓您從諮詢到出貨每個階段都清楚掌握
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {steps.map((s) => (
            <div key={s.num} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-green-200 hover:-translate-y-1 transition-all duration-300 flex gap-5">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 flex items-center justify-center bg-green-50 rounded-xl border border-green-100">
                  <i className={`${s.icon} text-[#4CAF50] text-xl`} />
                </div>
              </div>
              <div>
                <span className="text-[#4CAF50] font-bold text-[1.25rem] leading-none opacity-40">{s.num}</span>
                <h3 className="text-[#1a2e1a] font-bold text-[1rem] mb-1.5 mt-0.5">{s.title}</h3>
                <p className="text-gray-500 text-[0.875rem] leading-[1.75]">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/contact/form"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
          >
            立即開始合作
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
